import { toastr } from 'react-redux-toastr';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_AREAS,
  CLEAR_FDEPARTAMENTS,
  FLAG_GETTING_AREAS,
  FLAG_GETTING_DEPARTAMENTS,
  GET_AREAS,
  GET_DEPARTAMENTS,
} from '../types/hcm';
import { HCM_ENDPOINT } from '../../config/endpoints';

export const flagGettingDepartaments = (payload) => ({
  type: FLAG_GETTING_DEPARTAMENTS,
  payload,
});

export const getDepartaments =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingDepartaments(true));

      const url = `${HCM_ENDPOINT}/organization/departments/${organizationId}`;

      const response = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
      });

      await isErrorResponse(response, null, dispatch);

      const departments = await response.json();

      dispatch({
        type: GET_DEPARTAMENTS,
        payload: departments,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingDepartaments(false));
    }
  };

export const clearDepartaments = () => ({
  type: CLEAR_FDEPARTAMENTS,
});

export const flagGettingAreas = (payload) => ({
  type: FLAG_GETTING_AREAS,
  payload,
});

export const getAreas =
  ({ organizationId }) =>
  async (dispatch) => {
    try {
      dispatch(flagGettingAreas(true));

      const url = `${HCM_ENDPOINT}/organization/areas/${organizationId}`;

      const response = await fetch(url, {
        ...DEFAULT_GET_CONFIG,
      });

      await isErrorResponse(response, null, dispatch);

      const areas = await response.json();

      dispatch({
        type: GET_AREAS,
        payload: areas,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingAreas(false));
    }
  };

export const clearAreas = () => ({
  type: CLEAR_AREAS,
});
